import zhCN from "./List/zh-CN.js";
import enUS from "./List/en-US.js";
export default {
  "en-US": enUS,
  "zh-CN": zhCN,
};
